import { render } from "./FormerCompany.vue?vue&type=template&id=736afaae&scoped=true"
import script from "./FormerCompany.vue?vue&type=script&lang=js"
export * from "./FormerCompany.vue?vue&type=script&lang=js"

import "./FormerCompany.vue?vue&type=style&index=0&id=736afaae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736afaae"]])

export default __exports__